import { SVGProps } from "react";

export const TickFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="16" height="16" rx="8" fill="currentColor"/>
    <rect x="1" y="1" width="16" height="16" rx="8" stroke="currentColor"/>
    <path d="M6.5 8.9248L8.30239 11L11.5 7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
